export default function SectionHead({
  eyebrow,
  title,
  desc,
  align = "left",
  className = "",
}: {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  className?: string;
}) {
  const center = align === "center";
  return (
    <div className={`${center ? "mx-auto max-w-2xl text-center" : ""} ${className}`}>
      {eyebrow && (
        <p className={`eyebrow ${center ? "justify-center" : ""}`}>
          <span className="eyebrow-line" />
          {eyebrow}
          {center && <span className="eyebrow-line" />}
        </p>
      )}
      <h2 className={`mt-3 text-2xl font-bold leading-tight tracking-tight text-foreground-950 md:text-[2rem] ${center ? "" : ""}`}>
        {title}
      </h2>
      {desc && <p className={`mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px] ${center ? "mx-auto" : ""}`}>{desc}</p>}
    </div>
  );
}